/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_Importing_MediaInputs */

const en_load_project_file_status_importing_media = /** @type {(inputs: Load_Project_File_Status_Importing_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importing media...`)
};

const fr_load_project_file_status_importing_media = /** @type {(inputs: Load_Project_File_Status_Importing_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation des medias...`)
};

const de_load_project_file_status_importing_media = /** @type {(inputs: Load_Project_File_Status_Importing_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medien werden importiert...`)
};

const it_load_project_file_status_importing_media = /** @type {(inputs: Load_Project_File_Status_Importing_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione dei contenuti multimediali...`)
};

const ru_load_project_file_status_importing_media = /** @type {(inputs: Load_Project_File_Status_Importing_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт медиафайлов...`)
};

const es_load_project_file_status_importing_media = /** @type {(inputs: Load_Project_File_Status_Importing_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando medios...`)
};

const zh_cn2_load_project_file_status_importing_media = /** @type {(inputs: Load_Project_File_Status_Importing_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在导入媒体...`)
};

const ja_load_project_file_status_importing_media = /** @type {(inputs: Load_Project_File_Status_Importing_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアをインポートしています...`)
};

const hi_load_project_file_status_importing_media = /** @type {(inputs: Load_Project_File_Status_Importing_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया आयात किया जा रहा है...`)
};

const pt_pt2_load_project_file_status_importing_media = /** @type {(inputs: Load_Project_File_Status_Importing_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando mídia...`)
};

/**
* | output |
* | --- |
* | "Importing media..." |
*
* @param {Load_Project_File_Status_Importing_MediaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_importing_media = /** @type {((inputs?: Load_Project_File_Status_Importing_MediaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_Importing_MediaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_load_project_file_status_importing_media(inputs)
	if (locale === "de") return de_load_project_file_status_importing_media(inputs)
	if (locale === "it") return it_load_project_file_status_importing_media(inputs)
	if (locale === "ru") return ru_load_project_file_status_importing_media(inputs)
	if (locale === "es") return es_load_project_file_status_importing_media(inputs)
	if (locale === "zh-CN") return zh_cn2_load_project_file_status_importing_media(inputs)
	if (locale === "ja") return ja_load_project_file_status_importing_media(inputs)
	if (locale === "hi") return hi_load_project_file_status_importing_media(inputs)
	if (locale === "pt-PT") return pt_pt2_load_project_file_status_importing_media(inputs)
	return en_load_project_file_status_importing_media(inputs)
});